import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { NonOpsDetailProvider } from "presentation/store/NonOps/NonOpsDetailProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import NonOpsDetailMaintenance from "presentation/view/section/NonOps/Detail/NonOpsDetailMaintenance";
import { GridStyles } from "veronica-ui-component/dist/component/core/styled/table.styled";

const NonOpsContDetailMain = () => {
    return <ANAInfoWrapper permission={Permission.NON_OPS_CHARGE_DETAIL}>
        <MessageBarWrapper>
            <NonOpsDetailProvider>
                <GridStyles/>
                <NonOpsDetailMaintenance/>
            </NonOpsDetailProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default NonOpsContDetailMain;